import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import AppBaseComponent from '../../../components/AppBaseComponent';
import tapIcon from "../../../services/TapIcon";
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from 'react-toastify';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Link } from 'react-router-dom';
import Status from '../../../components/ui/Status';
import { DisplayListPagination } from '../../../components/TapUi';
import uuid from 'react-uuid';
import CurrencyFormatter from '../../../services/CurrencyFormatter';

class DemandHistoryModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.cancelItemFormInit               =       {
            notes                             :       '',
        }

        this.state                            =         {
            demandHistoryList             :         [],
            demandDetailLoading          :         false,
            itemName                          :         '',
            itemCode                            :       '',
            itemData                          :         null,
            asset_id                          :         null,
            workstation_id                    :         null,
            listing_tbl_page                  :          1,
            listingMeta                       :          null,
            totalListingCount                 :         0,
        };
        this.demandsDetailModalId      =   uuid();
    }
    
    
    
    componentDidMount(){
        this.viewDemandHistoryModal             =   new Modal(document.getElementById(this.demandsDetailModalId), {keyboard: false, backdrop :false});
    }

    modalInit                       =   (data,workstation_id,asset_id,demand_for)  =>  {
        this.viewDemandHistoryModal.show()
            if(data){
                  this.setState({
                    itemData        :        data,
                    workstation_id  :        workstation_id ? workstation_id : null,
                    asset_id        :        asset_id ? asset_id : null
                  },() => this.fetchDemandHistoryData())
            }
    }
   
    fetchDemandHistoryData     =       (page = 1)      =>      {
        this.setState({demandDetailLoading : true, demandHistoryList : [],listing_tbl_page: page});
        let params =  {
                search_item_ids             :    this.state.itemData ? [this.state.itemData.id] : null,
                page                        :    page,
                action                      :   'data',
                for_report                  :   'N',
        }
                    
        HttpAPICall.withAthorization('GET',  INVENTORY_API_BASE_URL_2  + '/item_demand/report/item-wise', this.props.access_token, {...params}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                demandHistoryList :    respData.data,
                itemName              :    this.state.itemData ? this.state.itemData.name : '',
                itemCode              :    this.state.itemData ? this.state.itemData.item_code : '',
                listingMeta           :     respData,
                totalListingCount     :     respData.total,
            },()=>  this.viewDemandHistoryModal.show())
        
        }).then(() => {
            this.setState({demandDetailLoading : false});
        });
    }

    
      demandHistoryModalJsx                     =   ()  =>  {
        console.log(this.state.demandHistoryList);
        
          return (
              <div className="modal fade" id={this.demandsDetailModalId} tabIndex="-1">
                  <div className="modal-dialog modal-xl modal-dialog-scrollable">
                      <div className="modal-content  ">
                          <div className="modal-header">
                              <h5 className="modal-title" id="addItemModalLabel">Demand History</h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className='p-1 bg-light border-bottom'>
                              <table className='table table-sm mb-0 table-borderless text-sm'>
                                  <tbody>
                                     
                                      <tr>
                                          <td style={{ width: "15%" }}> Item  </td>
                                          <th>{this.state.itemName  ?this.state.itemName : "-"}</th>
                                      </tr>
                                      <tr>
                                          <td style={{ width: "15%" }}> Item Code  </td>
                                          <th>{this.state.itemCode  ?this.state.itemCode : "-"}</th>
                                      </tr>

                                  </tbody>
                              </table>
                          </div>
                          <div className="modal-body ">
                              {!this.state.demandDetailLoading ?
                                  <table className="table table-bordered table-fixed table-sm align-middle bg-white">
                                      <thead className="align-middle table-secondary">
                                          <tr>
                                            
                                             <th className='text-center' style={{ width: "12%" }}>Transaction Date</th>
                                              <th className='text-center' style={{ width: "10%" }}>Transaction ID</th>
                                              <th className="text-center" style={{ width: "22%" }}>Warehouse</th>
                                              <th className="text-center" style={{ width: "20%" }}>Demand for</th>
                                              <th scope="col" style={{ width: "8%" }} > Status</th>
                                              <th scope="col" style={{ width: "6%" }} > Qty</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {this.state.demandHistoryList.length > 0
                                              ? (this.state.demandHistoryList.map((rowData, k) => {
                                                  return (<tr>
                                                    <td className='text-center'>{rowData.transaction_date}</td>
                                                      <td className='text-center'>{rowData.transaction_id}</td>
                                                      
                                                      <td>{rowData.warehouse.name}</td>
                                                      <td>
                                                          {rowData.demand_for == 'asset'
                                                              ? (rowData.asset ? rowData.asset.name + ' ' : '')
                                                              : null
                                                          }
                                                          {rowData.demand_for == 'workstation'
                                                              ? (rowData.workstation ? rowData.workstation.workstation_name + ' ' : '')
                                                              : null
                                                          }
                                                           {rowData.demand_for == "sub_assembly"
                                                              ? (rowData.sub_assembly ? rowData.sub_assembly.name + ' ' : '')
                                                              : null
                                                          }
                                                          {rowData.demand_for == 'employee'
                                                              ? (rowData.employee ? rowData.employee.display_full_name + ' ' : '')
                                                              : null
                                                          }
                                                          ({rowData.demand_for == 'asset' ? 'Asset' : rowData.demand_for == 'workstation' ? 'Workstation' : "Employee"})
                                                      </td>
                                                      <td>{rowData.status && rowData.status.name ? rowData.status.name : "-"}</td>
                                                      <td className="text-center">{rowData.qty}</td>
                                                  </tr>);

                                              }))
                                              : (<tr><td className="text-center" colSpan={9}>No Record Found</td></tr>)
                                          }
                                      </tbody>
                                  </table>
                                  : <Loader />}
                              <DisplayListPagination
                                  meta={this.state.listingMeta}
                                  onPageChange={(e) => this.fetchDemandHistoryData(e.selected + 1)}
                              />
                          </div>
                      </div>
                  </div>
              </div>
          );
    }

    render() {
        return (<Ax>{this.demandHistoryModalJsx()}</Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        default_currency        :   state.app && state.app.default_currency ? state.app.default_currency : 'INR',
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(DemandHistoryModal);
